export default __webpack_public_path__ + "static/39442-becd609e84460246d0b20dc200a8e073.png";